import { render } from "./AdminConfiguracionParametros.vue?vue&type=template&id=69a04f34&scoped=true"
import script from "./AdminConfiguracionParametros.vue?vue&type=script&lang=js"
export * from "./AdminConfiguracionParametros.vue?vue&type=script&lang=js"

import "./AdminConfiguracionParametros.vue?vue&type=style&index=0&id=69a04f34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a04f34"]])

export default __exports__